import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { useQuery } from '@tanstack/vue-query'
import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'
import { useRoute, useRouter } from 'vue-router'
import { computed, unref, type MaybeRef } from 'vue'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()
  const router = useRouter()
  const route = useRoute()

  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      if (data.id) {
        return http.put(`/role/${data.id}`, data)
      } else {
        return http.post(`/role/`, data)
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['auth'] })
    },
  })

  const sendForm = async (data: any, valid: boolean) => {
    if (!valid) return

    try {
      const { data: role } = await mutation.mutateAsync(data)

      addSuccess(trs('itf.saved'))

      if (role) await router.push({
          name: 'objects.groups.admin',
          params: {
            ...route.params,
            section: 'roles',
            action: 'edit',
            entity_id: role,
          },
      })
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}

export const useLoadRoleObjectTypes = (groupId: MaybeRef<number>) => {
  const http = useHttp()

  const resolvedGroupId = computed(() => Number(unref(groupId)) || 0)

  return useQuery({
    queryKey: computed(() => ['role_status_subscription_object_types', resolvedGroupId.value]),
    queryFn: () =>
      http.get(`/inventory/group/${resolvedGroupId.value}/object-types`, {
        page: 1,
        per_page: 1000,
      }),
    retry: false,
    enabled: computed(() => resolvedGroupId.value > 0),
  })
}
